const reasons = {
  COMMENT_OFFENSIVE: 'COMMENT_OFFENSIVE',
  COMMENT_SPAM: 'COMMENT_SPAM',
  COMMENT_OTHER: 'COMMENT_OTHER',
};

export const { COMMENT_OFFENSIVE, COMMENT_SPAM, COMMENT_OTHER } = reasons;
